/* Navita · Cores da box (blocks/navita-cores-box.liquid) — substitui o Aris Options.
   As <select> escondidas são a fonte de verdade (vão no formulário como properties[Cor N]);
   aqui só se desenha a escolha por espaços + paleta e se impede juntar ao carrinho com cores em falta. */
if (!customElements.get('navita-cores-box')) {
  customElements.define(
    'navita-cores-box',
    class NavitaCoresBox extends HTMLElement {
      connectedCallback() {
        if (this.dataset.pronto) return;
        this.dataset.pronto = '1';
        this.ativo = 0;
        this.listas = [...this.querySelectorAll('select[data-lista]')];
        this.espacos = [...this.querySelectorAll('[data-espaco]')];
        this.cores = [...this.querySelectorAll('[data-cor]')];
        this.aviso = this.querySelector('.navita-cores__aviso');
        this.seccao = this.closest('.shopify-section') || document.body;
        this.amostras = {};
        for (const c of this.cores) this.amostras[c.dataset.cor] = c.querySelector('.navita-cores__amostra').style.background;

        this.addEventListener('click', (e) => {
          const espaco = e.target.closest('[data-espaco]');
          if (espaco) return this.ativar(Number(espaco.dataset.espaco));
          const cor = e.target.closest('[data-cor]');
          if (cor) this.escolher(cor.dataset.cor);
        });
        for (const l of this.listas) l.addEventListener('change', () => this.desenhar());

        // Juntar ao carrinho (botão principal ou barra fixa, que clica no principal): validar antes do tema.
        this.aoClicar = (e) => {
          const botao = e.target.closest('button[type="submit"], [ref="addToCartButton"]');
          if (!botao || !this.seccao.contains(botao)) return;
          // (form.id não serve: o formulário tem um campo chamado "id", a variante)
          if (botao.form && botao.form.getAttribute('id') !== this.dataset.form) return;
          const faltam = this.listas.filter((l) => !l.value);
          if (!faltam.length) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          this.mostrarFalta(faltam);
        };
        document.addEventListener('click', this.aoClicar, true);

        this.classList.add('is-pronto');
        this.desenhar();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.aoClicar, true);
      }

      ativar(i) {
        this.ativo = i;
        this.desenhar();
      }

      escolher(nome) {
        const lista = this.listas[this.ativo];
        if (!lista) return;
        lista.value = nome;
        lista.dispatchEvent(new Event('change', { bubbles: true }));
        // passar ao próximo espaço vazio (se houver)
        const n = this.listas.length;
        for (let k = 1; k <= n; k++) {
          const j = (this.ativo + k) % n;
          if (!this.listas[j].value) {
            this.ativo = j;
            break;
          }
        }
        this.aviso.hidden = true;
        this.desenhar();
      }

      desenhar() {
        this.listas.forEach((l, i) => {
          const espaco = this.espacos[i];
          if (!espaco) return;
          const circulo = espaco.querySelector('.navita-cores__circulo');
          espaco.classList.toggle('is-ativo', i === this.ativo);
          espaco.setAttribute('aria-pressed', i === this.ativo ? 'true' : 'false');
          espaco.classList.toggle('tem-cor', !!l.value);
          if (l.value) espaco.classList.remove('is-falta');
          circulo.style.background = l.value ? this.amostras[l.value] || '' : '';
          espaco.querySelector('[data-nome]').textContent = l.value;
        });
        const atual = this.listas[this.ativo];
        for (const c of this.cores) c.setAttribute('aria-selected', atual && atual.value === c.dataset.cor ? 'true' : 'false');
        const rotulo = this.espacos[this.ativo]?.querySelector('.navita-cores__rotulo')?.textContent || '';
        this.querySelector('[data-estado-rotulo]').textContent = rotulo + ':';
        this.querySelector('[data-estado-nome]').textContent = atual?.value || '—';
        this.seccao.classList.toggle('navita-cores-incompletas', this.listas.some((l) => !l.value));
      }

      mostrarFalta(faltam) {
        const nomes = faltam.map((l) => this.espacos[Number(l.dataset.lista)]?.querySelector('.navita-cores__rotulo')?.textContent || '');
        for (const l of faltam) this.espacos[Number(l.dataset.lista)]?.classList.add('is-falta');
        this.aviso.textContent = (this.dataset.aviso || '[cores]').replace('[cores]', nomes.join(', '));
        this.aviso.hidden = false;
        this.ativo = Number(faltam[0].dataset.lista);
        this.desenhar();
        this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  );
}
